export default "__VITE_ASSET__IbgxCKO0__"